import script from "./CollectionPolicyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionPolicyModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73496d1d"]])

export default __exports__